import { SelectListItem } from "../../Components/Layout/Selectors/General/GeneralSelect"
import { AcademyEvent, AcademyVerified } from "../../Api/Events/Academy/academyEvents.types"

export type AcademyFilterObject = {
  participant?: string
  state?: string
  month?: string
  training?: string
}

export type ParticipantType = {
  id: number
  label: string
  value: string
}

export const participantTypes: ParticipantType[] = [
  { id: 0, label: 'All', value: 'all' },
  { id: 1, label: 'Boys', value: 'boys' },
  { id: 2, label: 'Girls', value: 'girls' },
]

export type AcademyHookReturns = {
    academyEvents: AcademyEvent[]
    verifiedClubs: AcademyVerified[]
    stateList: SelectListItem[]
    monthList: SelectListItem[]
    trainingList: SelectListItem[]
    stateSelect: string
    monthSelect: string
    trainingSelect: string
    participantSelect: ParticipantType
    filteredList: AcademyEvent[]
    loading: boolean
    verifiedLoading: boolean
    handleFilterChange: (filterType: string, value: string) => void
    handleReset: () => void
    getGameWeekendEvents: (market: string) => AcademyEvent | undefined
    returnFilteredEvents: (filterObj: AcademyFilterObject) => AcademyEvent[]
  }
